import React from "react";
import MasterLayout from "@layouts/MasterLayout.react";
import { Div, Image } from "@components/Generics.react";

export default function HelpDesk(props) {

    const HelpDesk = () => {
        return (
            <Div centered >
            <Image snubbed src="/assets/images/coming_soon.png" alt="Coming Soon" />
          </Div>
        );
      };
    

    const pageContent = (
        <MasterLayout
            title={"Welcome"}
            mainPanel={<HelpDesk />}
            // rightPanelName={rightPanelName}
            // rightPanel={""}
            rootPage={true}
        />
    );

    return pageContent;
}